import { SCENARIO } from 'actionTypes';
import actionsFactory from 'utils/redux/baseEntitiesFactory/actions';
import reducerFactory from 'utils/redux/baseEntitiesFactory/reducer';
import sagasFactory from 'utils/redux/baseEntitiesFactory/sagas';
import thunkFactory from 'utils/redux/baseEntitiesFactory/thunk';

// ACTIONS
const rawActions = actionsFactory(SCENARIO);
const actions = { ...rawActions, ...thunkFactory(SCENARIO, '/scenarios/') };
export { actions };

// REDUCER
const initialState = {
  ids: [],
  models: {},
  loaded: false,
  loading: false,
  errorMessage: '',
  submitting: false
};

export default reducerFactory(SCENARIO, initialState);

// SAGAS
const sagas = sagasFactory(SCENARIO, '/scenarios/', { scopedByAccount: true });
export { sagas };

